import { render, staticRenderFns } from "./shapeView.vue?vue&type=template&id=32fbd96a&lang=html"
import script from "./shapeView.vue?vue&type=script&lang=js"
export * from "./shapeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports